import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, Filter, Text, Icon } from 'components'
import { useFilter } from 'store'
import styles from './FiltersModal.module.scss'

const FiltersModal = ({
  opened,
  closeModal,
  childrenElement,
  showReducedFilters,
}) => {
  const {
    $filter,
    clearAllFiltersClick,
    setFieldAndScroll,
    toggleFilter,
    setSelectedLocalities,
    removeSelectedLocality,
    setFieldManually,
    toggleUniqueCheckbox,
    setMinValueRange,
    setMaxValueRange,
    setCampaign,
    setCurrentBanner,
  } = useFilter()
  const [localFilter, setLocalFilter] = useState($filter)
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false)

  useEffect(() => {
    setLocalFilter($filter)
  }, [$filter])

  const close = () => {
    document.getElementById('list').scrollIntoView()
    closeModal()
  }

  const save = () => {
    close()
  }

  const reset = () => {
    clearAllFiltersClick()
  }

  const basicFilters = [
    'locality',
    'selectedLocalities',
    'surroundingsSearch',
    'campaign',
    'secondCampaign',
    'purpose',
    'propertyType',
    'value',
  ]

  const advancedFilters = [
    'saleCategory',
    'listingType',
    'status',
    'purchaseType',
    'legalDispute',
    'debts',
    'visits',
    'discount',
    'seller',
  ]

  return (
    <Modal
      opened={opened}
      closeModal={closeModal}
      closeButtonPosition="left"
      closeClassName={styles.filterModalClear}
      className={styles.modal}
    >
      <div className={styles.filtersContainer}>
        <div className={styles.header}>
          <Text fontSize="large" bold>
            Refinar busca
          </Text>
        </div>
        <button
          type="button"
          className={styles.clearLink}
          onClick={() => reset()}
        >
          Limpar
        </button>
        <Filter
          className={styles.filterSection}
          filter={localFilter}
          setField={setFieldAndScroll}
          toggleFilter={toggleFilter}
          type="modal"
          setSelectedLocalities={setSelectedLocalities}
          removeSelectedLocality={removeSelectedLocality}
          specificFilters={basicFilters}
          setCampaign={setCampaign}
          setCurrentBanner={setCurrentBanner}
          setFieldManually={setFieldManually}
          setMinValueRange={setMinValueRange}
          setMaxValueRange={setMaxValueRange}
        />
        {!showReducedFilters && (
          <button
            type="button"
            className={styles.showAdvancedFiltersButton}
            onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
          >
            Ver filtros avançados
            <Icon
              type="arrow"
              size={20}
              className={
                showAdvancedFilters ? styles.arrowOpen : styles.arrowClose
              }
            />
          </button>
        )}
        {showAdvancedFilters && (
          <Filter
            className={styles.filterSection}
            filter={localFilter}
            setField={setFieldAndScroll}
            toggleFilter={toggleFilter}
            type="modal"
            setCampaign={setCampaign}
            setCurrentBanner={setCurrentBanner}
            setSelectedLocalities={setSelectedLocalities}
            removeSelectedLocality={removeSelectedLocality}
            specificFilters={advancedFilters}
            setFieldManually={setFieldManually}
            toggleUniqueCheckbox={toggleUniqueCheckbox}
            setMinValueRange={setMinValueRange}
            setMaxValueRange={setMaxValueRange}
          />
        )}
        {childrenElement}
        <span className={styles.confirmButtonContainer}>
          <Button className={styles.confirmButton} onClick={() => save()}>
            Aplicar Filtros
          </Button>
        </span>
      </div>
    </Modal>
  )
}

FiltersModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  childrenElement: PropTypes.element,
  showReducedFilters: PropTypes.bool,
}

FiltersModal.defaultProps = {
  childrenElement: <></>,
  showReducedFilters: false,
}

export default React.memo(FiltersModal)
